import { OfferDuplicationService } from '@occc-app/offerDuplicationService';
import { Operation } from '@occc-app/offerHelpers/types';
import { makeEarningMechanismCreateOperation } from '@occc-app/offerHelpers/operations/earningMechanism';
import { makeMarketingContentCreateOperation } from '@occc-app/offerHelpers/operations/marketingContent';
import { makeCreateLimitOperation } from '@occc-app/offerHelpers/operations/limits';
import { makeCreateConstraint } from '@occc-app/offerHelpers/operations/createConstraintOperation.utils';

export function getOfferDuplicationOperations(
  offerId: string,
  offerInputs: ReturnType<(typeof OfferDuplicationService)['prototype']['copy']>,
) {
  const { earningMechanismInput, getMarketingContentsInput, getDisplayCategoriesInput } =
    offerInputs;
  const operations: Operation[] = [];

  // Step: Earning Mechanism
  if (earningMechanismInput) {
    operations.push(makeEarningMechanismCreateOperation(offerId, earningMechanismInput));
  }

  // Step: Marketing Content
  const marketingContentsInput = getMarketingContentsInput(offerId);
  if (marketingContentsInput) {
    operations.push(makeMarketingContentCreateOperation(marketingContentsInput));
  }

  // Step: Display Categories
  const displayCategoriesInput = getDisplayCategoriesInput(offerId);
  if (displayCategoriesInput) {
    operations.push({
      name: 'offerDisplayCategoriesCreateOrUpdate',
      variables: {
        input: displayCategoriesInput,
      },
    });
  }

  // Step: Constraints
  offerInputs.constraintInputs.forEach((constraintInput) => {
    operations.push(makeCreateConstraint(offerId, constraintInput));
  });

  // Step: Limits
  offerInputs.limitInputs.forEach((limitInput) => {
    operations.push(makeCreateLimitOperation(offerId, limitInput));
  });

  return operations;
}
